import React from 'react';
import { motion } from 'framer-motion';

const row = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};
const slideL = {
  hidden: { opacity: 0, x: -28 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};
const slideR = {
  hidden: { opacity: 0, x: 28 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function OurPromiseSection() {
  return (
    <section className="w-full bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Big, bold title */}
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
          className="text-5xl md:text-6xl font-extrabold tracking-tight text-neutral-900 text-center mb-16 md:mb-24"
        >
          Our Promise to You
        </motion.h2>

        <div className="space-y-20 md:space-y-28">
          {/* Row 1 */}
          <motion.div
            className="grid md:grid-cols-12 items-start gap-10"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={row}
          >
            <motion.h3
              className="md:col-span-5 text-4xl md:text-5xl font-extrabold italic text-neutral-900"
              variants={slideL}
            >
              Global <br className="hidden md:block" />
              Perspective
            </motion.h3>

            <motion.div className="md:col-span-7" variants={slideR}>
              <div className="max-w-3xl">
                <p className="text-xl md:text-2xl text-neutral-800 leading-9 md:leading-10 italic mb-4">
                  We offer opportunities with our clients across Europe, MENA, US and remote.
                </p>
                <p className="text-xl md:text-2xl text-neutral-800 leading-9 md:leading-10 italic">
                  Our clients seek top-tier talent from around the world, often operating across multiple
                  time zones and financial markets. In response, we have developed deep expertise to meet
                  these global demands.
                </p>
              </div>
            </motion.div>
          </motion.div>

          {/* Row 2 (mirrored) */}
          <motion.div
            className="grid md:grid-cols-12 items-start gap-10"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={row}
          >
            <motion.div className="md:col-span-7 md:order-1 order-2" variants={slideL}>
              <div className="max-w-3xl md:ml-auto">
                <p className="text-xl md:text-2xl text-neutral-800 leading-9 md:leading-10 italic md:text-right">
                  We operate with the utmost discretion, providing confidential guidance to both clients and
                  candidates—whether building high-performing teams or advancing individual careers.
                </p>
              </div>
            </motion.div>

            <motion.h3
              className="md:col-span-5 md:text-right text-4xl md:text-5xl font-extrabold italic text-neutral-900 md:order-2 order-1"
              variants={slideR}
            >
              Confidential <br className="hidden md:block" />
              &amp; Trusted
            </motion.h3>
          </motion.div>

          {/* Row 3 */}
          <motion.div
            className="grid md:grid-cols-12 items-start gap-10"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={row}
          >
            <motion.h3
              className="md:col-span-5 text-4xl md:text-5xl font-extrabold italic text-neutral-900"
              variants={slideL}
            >
              Specialist <br className="hidden md:block" />
              Knowledge
            </motion.h3>

            <motion.div className="md:col-span-7" variants={slideR}>
              <div className="max-w-3xl">
                <p className="text-xl md:text-2xl text-neutral-800 leading-9 md:leading-10 italic">
                  We possess in-depth insight into the systematic trading landscape, with a strong grasp of
                  the unique characteristics of different markets, regions, and trading strategies.
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
